import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useCurrentUserTeams } = getCRUDHooks({
  entityName: 'currentUserTeam',
  find: ({ filters }) => clientApi.getOCClient().helpers.user.me.findTeams(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useCurrentUserTeams };
